'use client';
import React, {useState} from 'react';
import {connect} from 'react-redux';

import {getListingSubscriptions} from 'features/vip/actions';
import {getListingType} from 'utils/helpers';
import {hideModal} from 'features/modal/slice';
import {editListing, getAccountListingsClean} from 'features/listings/actions';
import {notifySuccessWithTimeout} from 'features/notification/slice';
import ChangeListingsTypeForm from "../components/ChangeListingsTypeForm/ChangeListingsTypeForm";

let ChangeListingsTypeFormContainer = (props) => {
    const [state, setState] = useState({ apiSuccess: [], apiErrors: [], savedCount: 0, isSaving: false, hasFinishedSubmission: false });

    const handleClose = () => props.hideModal();
    const updateSavedCount = (prevState, newState) => {
        newState.savedCount = prevState.savedCount + 1;
        if (newState.savedCount >= props.listings.length) {
            newState.isSaving = false;
            newState.hasFinishedSubmission = true;
            props.getAccountListingsClean(props.accountId, 600);
        }
        return newState;
    }

    const handleSubmit = async () => {
        const {listings, toType} = props;
        const apiSuccess = []; // the only way that works to clear the success and errors
        const apiErrors = [];
        const newState = {
            isSaving: true,
            savedCount: 0,
            apiSuccess: apiSuccess,
            apiErrors: apiErrors,
        }
        setState(newState);

        listings.forEach((listing) => {
            let req = {
                listing_id: listing.listing_id,
                type: toType,
            };

            props.editListing(req, false)
                .then((data) => {
                    if (getListingType(listing) === 'vip' && toType && toType !== 'vip') {
                        props.getListingSubscriptions(listing.listing_id);
                    }
                    const newSuccessMessage = listing.listing_name + ': success';
                    setState((prevState) => {
                        return {...prevState, ...updateSavedCount(prevState, { apiSuccess: [...prevState.apiSuccess, newSuccessMessage ] }) }
                    });
                    return data;
                })
                .catch((response) => {
                    const newErrorMessage = listing.listing_name + ': ' + response.message;
                    const errors = [...state.apiErrors, listing.listing_name + ': ' + response.message];
                    setState((prevState) => {
                        return {...prevState, ...updateSavedCount(prevState, { apiErrors: [...prevState.apiErrors, newErrorMessage ] }) }
                    });
                    return response;
                });
        });
    };

    let includeVipWarning = false;
    props.listings.forEach(listing => {
        if (listing.listing_type === 'vip') {
            includeVipWarning = true;
        }
    })

    return (
        <ChangeListingsTypeForm
            {...props}
            {...state}
            includeVipWarning={includeVipWarning}
            handleSubmit={handleSubmit}
            handleClose={handleClose}
        />
    );
};

ChangeListingsTypeFormContainer = connect(
    (state, ownProps) => {
        const listings = ownProps.listings;
        const toType = ownProps.toType;
        return {
            listings,
            toType,
            isSaving: state.listings.isSaving
        };
    },
    {
        editListing,
        hideModal,
        getListingSubscriptions,
        notifySuccessWithTimeout,
        getAccountListingsClean,
    },
)(ChangeListingsTypeFormContainer);

export default ChangeListingsTypeFormContainer;
